import React from 'react';
import {
  Button, ButtonToolbar, Message, Modal,
} from 'rsuite';
import { PricingImportResult } from '../../api/apiTypes';
import { downloadData } from '../../utils/downloadData';

interface Props {
  response?: PricingImportResult;
  onClose: () => void;
}

export default function PricingImportResultDialog(
  { response, onClose }: Props,
): JSX.Element | null {
  if (!response) {
    return null;
  }

  const {
    total, updated, failed, report,
  } = response;

  function handleDownloadReport(): void {
    if (!report) {
      return;
    }

    downloadData(report, 'text/csv', 'import_report.csv');
  }

  return (
    <Modal open onClose={() => onClose()}>
      <Modal.Header closeButton={false}>
        <Modal.Title>
          Total number of processed rows
          {' '}
          {total}
          .
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {updated > 0 && (
          <Message
            showIcon
            type="success"
            header={`Successfully applied ${updated} rows.`}
          />
        )}
        {failed > 0 && (
          <Message
            showIcon
            type="error"
            header={`Failed to apply ${failed} rows.`}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar>
          {!!report && (
            <Button onClick={() => handleDownloadReport()}>
              Download report
            </Button>
          )}
          <Button appearance="primary" onClick={() => onClose()}>
            Close
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  );
}

PricingImportResultDialog.defaultProps = {
  response: undefined,
};
